// sans manoeuvre + need dimensions

import formInputsTypes from '../simulatorConstant';
import Torsion from 'assets/img/torsion.png';
import Traction from 'assets/img/traction.png';

const sensEnroulementTorsion = {
	id: 'PG-RS-TOR-SE',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'sensEnroulement',
	className: 'col-6',
	label: "Sens d'enroulement",
	nextStepData: false,
	options: [
		{
			id: 'PG-RS-TOR-SE-G',
			label: 'Gauche',
			value: 'Gauche',
			description: "- Sens d'enroulement : Gauche ",
		},
		{
			id: 'PG-RS-TOR-SE-D',
			label: 'Droite',
			value: 'Droite',
			description: "- Sens d'enroulement : Droite ",
		},
	],
};

// Diamètre du fil (torsion)
const diametreFilTorsion = {
	id: 'PG-RS-TOR-DF',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'diametreFil',
	className: 'col-6',
	label: 'Diamètre du fil (mm)',
	placeholder: '0',
	defaultValue: 0,
	nextStepData: sensEnroulementTorsion,
	validation: (value) => value > 0,
};

// Longueur intérieure (torsion)
const longueurInterieureTorsion = {
	id: 'PG-RS-TOR-LI',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'longueurInterieure',
	className: 'col-6',
	label: 'Longueur intérieure (mm)',
	placeholder: '0',
	defaultValue: 0,
	nextStepData: diametreFilTorsion,
	validation: (value) => value > 0,
};

// Longueur à vide (torsion)
const longueurAVideTorsion = {
	id: 'PG-RS-TOR-LAV',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'longueurAVide',
	className: 'col-6',
	label: 'Longueur à vide (mm)',
	placeholder: '0',
	defaultValue: 0,
	nextStepData: longueurInterieureTorsion,
	validation: (value) => value > 0,
};

// ---------- TRACTION FLOW ----------

// Diamètre du fil (traction)
const diametreFilTraction = {
	id: 'PG-RS-TRA-DF',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'diametreFil',
	className: 'col-6',
	label: 'Diamètre du fil (mm)',
	placeholder: '0',
	defaultValue: 0,
	nextStepData: false,
	validation: (value) => value > 0,
};

// Longueur à vide (traction)
const longueurAVideTraction = {
	id: 'PG-RS-TRA-LAV',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'longueurAVide',
	className: 'col-6',
	label: 'Longueur à vide (mm)',
	placeholder: '0',
	defaultValue: 0,
	nextStepData: diametreFilTraction,
	validation: (value) => value > 0,
};

// ---------- TYPE RESSORT ----------
export const typeRessort = {
	id: 'PG-RS-TYPE',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'typeRessort',
	className: 'col-12',
	label: 'Type de ressort',
	nextStepData: false,

	fetchData: (currentFormValue, fnSuccess) => {
		// doorType == enroulable / basculante / sectionnelle
		const doorType =
			currentFormValue?.Type?.value ||
			currentFormValue?.values?.Type?.value ||
			currentFormValue?.typePorte?.value ||
			currentFormValue?.typePorte?.label;

		const makeDesc = (type) => {
			if (type === 'torsion') {
				return (
					`Fourniture d’un ressort de torsion pour porte de garage ${doorType || ''}.\n` +
					`Le ressort est monté sur un axe, généralement positionné au-dessus de la porte, et permet de compenser le poids de la porte lors de l’ouverture et de la fermeture, assurant un fonctionnement équilibré et sécurisé.`
				);
			}

			// traction
			return (
				`Fourniture d’un ressort de traction pour porte de garage ${doorType || ''}.\n` +
				`Le ressort est installé de manière latérale et fonctionne par extension afin d’assister la manœuvre de la porte et de garantir une ouverture et une fermeture contrôlées.`
			);
		};

		const options = [
			{
				id: 'PG-RS-TOR',
				label: 'Torsion',
				value: 'Torsion',
				nextStep: longueurAVideTorsion,
				description: makeDesc('torsion'),
				imageUrl:Torsion
			},
			{
				id: 'PG-RS-TRA',
				label: 'Traction',
				value: 'Traction',
				nextStep: longueurAVideTraction,
				description: makeDesc('traction'),
				imageUrl:Traction
			},
		];

		fnSuccess(options);
	},
};
